import * as yup from 'yup';
import { ValidationSchemaTypeDistributorForm } from '../../services/types';

const validationSchema: ValidationSchemaTypeDistributorForm = {
  id: yup.string().optional(),
  name: yup
    .string()
    .required('O nome não pode estar vazio')
    .max(150, 'O nome pode ter até 150 caracteres'),
  cnpj: yup
    .string()
    .required('O CNPJ não pode estar vazio')
    .length(14, 'O CNPJ deve ter 14 caracteres numéricos'),
  zipCode: yup
    .string()
    .required('O CEP não pode estar vazio')
    .length(9, 'O CEP deve ter 7 caracteres numéricos'),
  state: yup
    .string()
    .required('O estado não pode estar vazio')
    .max(20, 'O estado pode ter até 20 caracteres'),
  city: yup
    .string()
    .required('A cidade não pode estar vazia')
    .max(50, 'O nome da cidade pode ter até 50 caracteres'),
  neighborhood: yup
    .string()
    .required('O bairro não pode estar vazio')
    .max(100, 'O bairro pode ter até 100 caracteres'),
  streetAddress: yup
    .string()
    .required('O endereço não pode estar vazio')
    .max(150, 'A rua pode ter até 150 caracteres'),
  streetNumber: yup
    .string()
    .required('O número não pode estar vazio')
    .max(10, 'O número pode ter até 10 dígitos'),
  complement: yup
    .string()
    .nullable()
    .max(50, 'O complemento pode ter até 50 caracteres'),
  phone: yup
    .string()
    .required('Telefone não pode estar vazio')
    .max(15, 'O telefone pode ter até 15 caracteres'),
  email: yup
    .string()
    .email('Insira um endereço de email válido')
    .max(100, 'O email pode ter até 100 caracteres'),
  feeType: yup.string().required('O tipo de taxa não pode estar vazio'),
  fee: yup
    .number()
    .typeError('A taxa deve ser um número')
    .positive('A taxa deve ser maior que 0')
    .lessThan(100, 'A taxa deve ser menor que 100')
    .min(0, 'A taxa deve ser maior ou igual a 0'),
  percantageLimit: yup
    .number()
    .nullable()
    .typeError('A porcentagem limite deve ser um número'),
  cellPhone: yup
    .string()
    .max(15, 'O celular pode ter até 15 caracteres')
    .nullable(),
  stateRegistration: yup.string().nullable(),
};

export default yup.object().shape(validationSchema);
